import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { Box, Drawer, Grid, Typography } from '@material-ui/core';
import AppBar from '../../Components/Header/newIndex';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDashboardCardArray } from '../../Utils/dashboardCards';
import Logo from '../../Assets/flame-logo.png';
// import Logo1 from '../../Assets/manipal-logo.svg';
import NewAdminPortalNavigation from '../../Components/SideNavigation/NewAdminPortalNavigation';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import routes from '../../Utils/routes.json';
import KenDialogBox from '../../global_components/KenDialogBox';

import Exam from './Exam/index';
import StudentStatus from './Exam/StudentStatus';
import KenSelectWrap from '../../global_components/KenSelect';
import QuestionPaper from './Exam/QuestionPaper';
import ChatSection from './Exam/QuestionPaper/ChatSection';
import SeatingPlan from './Exam/SeatingPlan/SeatingPlan';
import SeatingPlanArrangement from './Exam/SeatingPlan/SeatingPlanArrangement';
import Invigilation from './Exam/Invigilation/Invigilation';
import InvigilationAssign from './Exam/Invigilation/InvigilationAssign';
import InvigilationNotification from './Exam/Invigilation/InvigilationNotification';
import Evaluation from './Exam/Evaluation/Evaluation';
import Grading from './Exam/Invigilation/Grading/Grading';

import GradingSetting from './Exam/Invigilation/Grading/GradingSetting';
import ViewQuestionPaper from './Exam/QuestionPaper/ViewQuestionPaper';
import RevaluationRetest from './Exam/Revaluation Retest';
import ExamPlanner from './Exam/ExamPlanner/ExamPlanner';
import GradingDetails from './Exam/Invigilation/Grading/GradingDetails/GradingDetails';
import EvaluatorAssignment from './Exam/Evaluation/EvaluatorAssignment';
import SeatingExamTimeTableChild from './Exam/SeatingPlan/SeatingExamTimeTableChild';
import StudentGradingDetails from './Exam/Invigilation/Grading/StudentGradingDetails';
import RevalParent from './Exam/Revaluation Retest/RevalParent';
import Revulation from './Exam/Revaluation Retest/Revulation';
import RetestParent from './Exam/Revaluation Retest/RetestParent';
import Retest from './Exam/Revaluation Retest/Retest';
import StudentRequestQuePaper from './Exam/Revaluation Retest/StudentRequestQuePaper';

const drawerWidth = 260;
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    background: theme.palette.KenColors.background,
    padding: '0 32px',
    minHeight: '100vh',
    marginTop: 64,
    overflow: 'hidden',
  },
  containerWrap: {
    width: 'calc(100% - 260px)',
  },
  appBar: {
    [theme.breakpoints.up('smUp')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      zIndex: 1000,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerOpen: {
    width: drawerWidth,
    overflow: 'hidden',
    background: '#092682',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.KenColors.kenLogoColor,
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: 65,
    },
    [theme.breakpoints.down('xs')]: {
      width: 65,
    },
  },
  toolbar: theme.mixins.toolbar,
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '--Select--',
  },
  {
    label: 'Campus 1',
    value: '1',
  },
  {
    label: 'Campus 2',
    value: '2',
  },
];

const selectOptionsCourse = [
  {
    label: 'Select Course',
    value: '--Select--',
  },
  {
    label: 'Course 1',
    value: '1',
  },
  {
    label: 'Course 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '--Select--',
  },
  {
    label: 'Duration 1',
    value: '1',
  },
  {
    label: 'Duration 2',
    value: '2',
  },
];

const selectOptionsExamType = [
  {
    label: 'Select Exam Type',
    value: '--Select--',
  },
  {
    label: 'Exam Type 1',
    value: '1',
  },
  {
    label: 'Exam Type 2',
    value: '2',
  },
];

const AdminPortal = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [openDrawer, setOpenDrawer] = useState(true);

  // For Modal
  const [filterDialog, setfilterDialog] = useState(false);

  function handlefilterDialog() {
    setfilterDialog((prevState) => !prevState);
  }

  const handleClick = () => {
    history.push('/app/admin-management');
  };

  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };

  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const [selectValueDuration, setSelectValueDuration] = useState(
    selectOptionsDuration[0].value
  );
  const handleSelectChangeDuration = (e) => {
    setSelectValueDuration(e.target.value);
  };

  const [selectValueExamType, setSelectValueExamType] = useState(
    selectOptionsExamType[0].value
  );
  const handleSelectChangeExamType = (e) => {
    setSelectValueExamType(e.target.value);
  };

  return (
    <Box className={classes.mainContainer}>
      <div className={classes.sideNavWrap}>
        <Drawer
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            }),
          }}
          variant="permanent"
          open
        >
          <NewAdminPortalNavigation
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
          />
        </Drawer>
      </div>

      <div className={classes.containerWrap}>
        <AppBar
          logo={Logo}
          title="Admin Portal"
          handleClick={handleClick}
          history={history}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          cards={getDashboardCardArray(t)}
        />
        <Box className={classes.container}>
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <Route exact path={routes.adminManagement}>
                <Redirect to={routes.exam} />
              </Route>
              <Route exact path={routes.exam}>
                <Exam />
              </Route>
              <Route exact path={routes.studentStatus}>
                <StudentStatus />
              </Route>
              <Route exact path={routes.seatingPlan}>
                <SeatingPlan />
              </Route>
              <Route exact path={routes.invigilationProctoring}>
                <Invigilation />
              </Route>
              <Route exact path={routes.evaluation}>
                <Evaluation />
              </Route>
              <Route exact path={routes.examPlanner}>
                <ExamPlanner />
              </Route>
              <Route exact path={routes.grading}>
                <Grading />
              </Route>
              <Route exact path={routes.gradingDetails}>
                <GradingDetails />
              </Route>
              <Route exact path={routes.studentGradingDetails}>
                <StudentGradingDetails />
              </Route>
              <Route exact path={routes.invigilationProctoringNotification}>
                <InvigilationNotification />
              </Route>
              <Route exact path={routes.invigilationProctoringAssign}>
                <InvigilationAssign />
              </Route>
              <Route exact path={routes.seatingPlanArrangement}>
                <SeatingPlanArrangement />
              </Route>
              <Route exact path={routes.chatHistory}>
                <ChatSection />
              </Route>
              <Route exact path={routes.questionPaperView}>
                <ViewQuestionPaper />
              </Route>

              <Route exact path={routes.questionPaper}>
                <QuestionPaper />
              </Route>
              <Route exact path={routes.sessionScheduler}></Route>
              <Route exact path={routes.facultySection}>
                {/* <FacultyManagement /> */}
              </Route>
              <Route exact path={routes.gradingSetting}>
                <GradingSetting />
              </Route>
              <Route exact path={routes.revaluationRetest}>
                <RevaluationRetest />
              </Route>
              <Route exact path={routes.revaluation}>
                <RevalParent />
              </Route>
              <Route exact path={routes.retest}>
                <RetestParent />
              </Route>
              <Route exact path={routes.revaluationStudentList}>
                <Revulation />
              </Route>
              <Route exact path={routes.requestStudentQuestionPaper}>
                <StudentRequestQuePaper />
              </Route>
              <Route exact path={routes.retestStudentList}>
                <Retest />
              </Route>
              <Route exact path={routes.evaluatorAssign}>
                <EvaluatorAssignment />
              </Route>
            </Switch>
          </Suspense>
        </Box>
      </div>

      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Filter
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handlefilterDialog()}
        negativeButtonClick={() => handlefilterDialog()}
        positiveButtonClick={() => handlefilterDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectOptionsCourse}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCourse}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject"
              options={selectOptionsSubject}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Date"
              options={selectOptionsCampus}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Duration"
              options={selectOptionsDuration}
              value={selectValueDuration}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeDuration}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Type"
              options={selectOptionsExamType}
              value={selectValueExamType}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamType}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default AdminPortal;
